import { defineStore } from "pinia";

export const useDashboardEventsStore = defineStore("dashboardEvents", {
  state: () => {
    return {
      events: [] as { time: string; type: string; event: string }[],
    };
  },
});
